// import MyAccount from '../../../../assets/svgs/edit-profile.svg'
// import MyPassword from '../../../../assets/svgs/my-password.svg'
import MyContact from '../../../../assets/svgs/my-contact.svg'
import MyPurchase from '../../../../assets/svgs/my-purchase.svg'
import MyCollectibles from '../../../../assets/svgs/my-collectibles.svg'
import routeConstant from '../../../../lib/constants/routeConstant'

export const profileData = [
    // {
    //     id: 1,
    //     title: "My Account",
    //     icon: MyAccount,
    //     link: routeConstant.MY_ACCOUNT_PAGE
    // },
    {
        id: 1,
        title: "My Contact Info",
        icon: MyContact,
        link: routeConstant.MY_CONTACT
    },
    {
        id: 2,
        title: "My Purchase History",
        icon: MyPurchase,
        link: routeConstant.MY_PURCHASE
    },
    {
        id: 3,
        title: "My Collectibles",
        icon: MyCollectibles,
        link: routeConstant.MY_COLLECTIBLES
    },
]